import './styles.scss';
import { useState } from 'react';
import { Alert, Button, Grid, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Header, Input, PhoneInput } from '../../components';
import { http, stripNonNumbers, invalidPhone } from '../../helpers';

function CreateLab() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [officePhone, setOfficePhone] = useState('');
    const [officePhoneError, setOfficePhoneError] = useState('');
    const [cellPhone, setCellPhone] = useState('');
    const [cellPhoneError, setCellPhoneError] = useState('');
    const [success, setSuccess] = useState(false);
    const [fail, setFail] = useState(false);
    const [errorMessage, setErrorMessage] = useState('Something went wrong');

    const onSubmit = () => {
        if (!name) return setNameError('Name is required');
        if (invalidPhone(officePhone)) return setOfficePhoneError('Invalid office phone number');
        if (invalidPhone(cellPhone)) return setCellPhoneError('Invalid cell phone number');
        const url = '/case-api/labs';
        const body = {
            name,
            company,
            email,
            officePhone: stripNonNumbers(officePhone),
            cellPhone: stripNonNumbers(cellPhone),
        };

        return http
            .post(url, body)
            .then(() => {
                setSuccess(true);
                setFail(false);
                setTimeout(() => {
                    navigate('/labs');
                }, 700);
            })
            .catch(({ request }) => {
                const response = JSON.parse(request?.response);
                const error = response?.error;
                if (error) setErrorMessage(error);
                setSuccess(false);
                setFail(true);
            });
    };
    const getTooltip = () => {
        if (!name) return 'Name required';
        return '';
    };

    const updateCellPhone = (evt) => {
        const val = evt.target.value;
        if (!invalidPhone(val)) setCellPhoneError('');
        setCellPhone(val);
    };
    const updateOfficePhone = (evt) => {
        const val = evt.target.value;
        if (!invalidPhone(val)) setOfficePhoneError('');
        setOfficePhone(val);
    };

    return (
        <>
            <Header label="Create Lab" />
            <main className="create-lab-container">
                <Grid spacing={4} container direction="column" alignItems="center">
                    <Grid
                        className="form-field"
                        item
                        style={{ height: '50px', paddingTop: '0px' }}
                    >
                        {success && (
                            <Alert>
                                Success! Lab created
                            </Alert>
                        )}
                        {fail && (
                            <Alert severity="error">
                                { errorMessage }
                            </Alert>
                        )}
                    </Grid>
                    <Grid item>
                        <Input
                            className="form-field"
                            label="Lab Name"
                            variant="outlined"
                            value={name}
                            required
                            error={!!nameError}
                            helperText={nameError}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val) setNameError('');
                                setName(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Input
                            className="form-field"
                            label="Company Name"
                            variant="outlined"
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <Input
                            className="form-field"
                            label="Email"
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <PhoneInput
                            label="Office Phone"
                            value={officePhone}
                            onChange={updateOfficePhone}
                            errorText={officePhoneError}
                        />
                    </Grid>
                    <Grid item>
                        <PhoneInput
                            label="Cell Phone"
                            value={cellPhone}
                            onChange={updateCellPhone}
                            errorText={cellPhoneError}
                        />
                    </Grid>
                    <Grid item>
                        <Tooltip title={getTooltip()}>
                            <span>
                                <Button
                                    onClick={onSubmit}
                                    variant="outlined"
                                    style={{ border: '1px solid black', color: 'black' }}
                                >
                                    Submit
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>
                </Grid>
            </main>
        </>

    );
}
export default CreateLab;
